module.exports = __webpack_public_path__ + "static/media/exp.bd6455a1.svg";